import MedicationContent from 'components/Dashboard/cards/common/MedicationContent'
import Pharmacy from './Pharmacy'
import PendingVisit, { PharmacyModel } from 'types/Visit/PendingVisit'

type MedicalChartContentProps = {
  // TODO - improve type
  visit: any
  pharmacy: PharmacyModel
  prescriptionId: string
  name?: string
  quantity?: number
  refills: number
  daysSupply?: number
  directions: string
  unit: string
  notes?: string
  substitutions: string
  writtenDate: string
  isChangeButtonShown?: boolean
  removalForbidden?: boolean
  cancellationReason?: string
}

const MedicalChartContent = ({
  visit,
  prescriptionId,
  pharmacy,
  name,
  quantity,
  refills,
  daysSupply,
  directions,
  unit,
  notes,
  substitutions,
  writtenDate,
  isChangeButtonShown,
  removalForbidden,
  cancellationReason,
}: MedicalChartContentProps) => {
  return (
    <>
      <div>
        <p className="typography-caption text-neutral-500">Pharmacy</p>
        <Pharmacy pharmacy={pharmacy} visit={visit} isChangeButtonShown={isChangeButtonShown} />
      </div>

      <div>
        <p className="typography-caption text-neutral-500">Prescribed medication</p>

        <MedicationContent
          visit={visit}
          prescriptionId={prescriptionId}
          name={name}
          quantity={quantity}
          refills={refills}
          daysSupply={daysSupply}
          directions={directions}
          unit={unit}
          notes={notes}
          substitutions={substitutions}
          writtenDate={writtenDate}
          isChangeButtonShown={isChangeButtonShown}
          removalForbidden={removalForbidden}
          cancellationReason={cancellationReason}
        />
      </div>
    </>
  )
}

export default MedicalChartContent
